// NB: Stylesheet order matters to apply proper CSS priorities (which depend on the order selectors are declared in)
// Needs an extra line between each import to make Prettier / Organize Imports not sort it.

import "@/styles/main.css";

import "virtual:uno.css";

import { initBodyClasses } from "@/styles/bodyClasses.ts";
initBodyClasses();
